import { COOKIES, MonthInMs } from "constants/enum";

export const storeRakutenSiteID = (rakutenSiteID: string) => {
    const expiresDate = new Date(Date.now() + 3 * MonthInMs);

    document.cookie = `${
        COOKIES.RAKUTEN_SITE_ID_SERVICE_COOKIE
    }=${rakutenSiteID};path=/;expires=${expiresDate.toUTCString()}`;
};
